import { __assign, __extends } from "tslib";
import React, { Component } from "react";
import { View } from "react-native";
import { PnmacSectionListView, PnmacPageBubble, PnmacRowHeader, PnmacMediaQuery, PnmacMeta, PnmacText, PnmacHtmlToNative } from 'pnmac-universal-components';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import styles from '../styles/styles.js';
import { textStyle } from '../v2/theme';
var ContactUs = /** @class */function (_super) {
  __extends(ContactUs, _super);
  function ContactUs(props) {
    var _this = _super.call(this, props) || this;
    _this.expRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  ContactUs.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      translations = _a.translations,
      layout = _a.layout;
    var rateQuotesObj = {
      title: translations.RateQuotesText,
      data: [{
        label: translations.RateQuotesText,
        header: translations.RateQuotesText,
        value: translations.RateQuotes
      }]
    };
    var DATAEXPANDABLE = [{
      title: translations.ExistingLoanServicingText,
      data: [{
        label: translations.ExistingLoanServicingText,
        header: translations.ExistingLoanServicingText,
        value: translations.ExistingLoanServicing
      }]
    }, {
      title: translations.TroubleMakingPaymentsText,
      data: [{
        label: translations.TroubleMakingPaymentsText,
        header: translations.TroubleMakingPaymentsText,
        value: translations.TroubleMakingPayments
      }]
    }];
    if (layout.isPennymac) {
      DATAEXPANDABLE.splice(0, 0, rateQuotesObj);
    }
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      return /*#__PURE__*/React.createElement(View, {
        style: layout.mobile ? {
          padding: 10
        } : {
          paddingLeft: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.ContactUs
      }), /*#__PURE__*/React.createElement(PnmacPageBubble, {
        accessibilityRole: "header",
        ariaLevel: "1",
        containerStyles: {
          marginLeft: 10,
          marginBottom: 10,
          marginTop: 5
        },
        text: translations.ContactUs
      }), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacSectionListView, {
        ref: _this.expRef,
        openDefaults: [translations.ExistingLoanServicingText],
        data: DATAEXPANDABLE,
        collapsableSections: true,
        renderItem: function (_a, collapsed) {
          var item = _a.item;
          if (collapsed.some(function (s) {
            return s == item.header;
          })) {
            if (item.header == translations.RateQuotesText) {
              return /*#__PURE__*/React.createElement(View, {
                style: __assign({}, styles.contactUs.itemStyles)
              }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
                value: translations.RateQuotes,
                navigation: _this.props.navigation,
                layout: layout
              }));
            } else if (item.header == translations.ExistingLoanServicingText) {
              return /*#__PURE__*/React.createElement(View, {
                style: __assign({}, styles.contactUs.itemStyles)
              }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
                value: translations.ExistingLoanServicing,
                navigation: _this.props.navigation,
                layout: layout
              }));
            } else if (item.header == translations.TroubleMakingPaymentsText) {
              return /*#__PURE__*/React.createElement(View, {
                style: __assign({}, styles.contactUs.itemStyles)
              }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
                value: translations.TroubleMakingPayments,
                navigation: _this.props.navigation,
                layout: layout
              }));
            }
          } else {
            return null;
          }
        },
        renderSectionHeader: function (_a) {
          var _b, _c, _d, _e;
          var title = _a.section.title;
          var open = ((_c = (_b = _this.expRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1;
          return /*#__PURE__*/React.createElement(PnmacRowHeader, {
            rowHeaderStyles: styles.selectionListView.rowHeaderStyles,
            rowHeaderContainerStyles: layout.mobile ? {
              marginBottom: open ? 0 : 10,
              borderBottomWidth: open ? 1 : 0,
              borderBottomColor: "#EFEFEF",
              borderBottomLeftRadius: open ? 0 : 10,
              borderBottomRightRadius: open ? 0 : 10
            } : {
              borderBottom: open ? "1px solid #e9e9e9" : "none",
              borderBottomLeftRadius: open ? 0 : 10,
              borderBottomRightRadius: open ? 0 : 10
            },
            onClickExpand: function () {
              var _a;
              return (_a = _this.expRef) === null || _a === void 0 ? void 0 : _a.current.collapseItem(title);
            },
            item: /*#__PURE__*/React.createElement(PnmacText, {
              id: title,
              style: textStyle.formTitleSection
            }, title),
            isExpand: ((_e = (_d = _this.expRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.state.collapsed.indexOf(title)) > -1
          });
        }
      })));
    });
  };
  return ContactUs;
}(Component);
export { ContactUs };
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(ContactUs);